export const playSoundFile = (musicclass: string | undefined) => {
  if (!musicclass) return;

  const musicUrl = `/music/${musicclass}.wav`;

  return new Promise<string>((resolve) => {
    resolve(musicUrl);
  });
};
